module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bkt1",
    attrs: {
      "id": "d9e7kl45011"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e7011"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c8_r1#d6e7209",
      "id": "d7e7209"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e37631"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c9_r1#d6e386735",
      "id": "d7e386735",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e66531"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c10_r1#d6e689859",
      "id": "d7e689859",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e73261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c11_r1#d6e763065",
      "id": "d7e763065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e86401"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c12_r1#d6e905777",
      "id": "d7e905777",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e97751"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c13_r1#d6e1029387",
      "id": "d7e1029387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e108811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c14_r1#d6e1142397",
      "id": "d7e1142397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e117861"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c15_r1#d6e12352105",
      "id": "d7e12352105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e140511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c16_r1#d6e14850123",
      "id": "d7e14850123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e163771"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c17_r1#d6e17386143",
      "id": "d7e17386143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e168191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c18_r1#d6e17861147",
      "id": "d7e17861147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e174261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c19_r1#d6e18542153",
      "id": "d7e18542153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e186711"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c20_r1#d6e19840165",
      "id": "d7e19840165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e199071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c21_r1#d6e21210177",
      "id": "d7e21210177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e209811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c22_r1#d6e22318187",
      "id": "d7e22318187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e213811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c23_r1#d6e22729191",
      "id": "d7e22729191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e228551"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c24_r1#d6e24287205",
      "id": "d7e24287205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e244181"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c25_r1#d6e25964219",
      "id": "d7e25964219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e257761"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c26_r1#d6e27451231",
      "id": "d7e27451231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e267441"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c27_r1#d6e28540239",
      "id": "d7e28540239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e271561"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c28_r1#d6e28964243",
      "id": "d7e28964243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e273371"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c29_r1#d6e29149245",
      "id": "d7e29149245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e280321"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c31_r1#d6e29868251",
      "id": "d7e29868251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion questions/ study guide")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9e282811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SWIN_ISBNXXXXXXXXX_epub_c32_r1#d6e30176253",
      "id": "d7e30176253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1cb8fd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SWIN_ISBNXXXXXXXXX_epub_c7_r1.vue
// module id = 75
// module chunks = 0